export default __webpack_public_path__ + "static/media/tames_assist_logo.fe94359e.png";